"use client";

import { useEffect, useState } from "react";
import { Delta, PillStatut } from "@/components/Icons";
import { TYPE_LIB } from "@/lib/data";
import { useStock } from "@/context/StockContext";
import { euro, statut } from "@/lib/utils";

export function Panel() {
  const { panelRef, fermerPanel, findProduit, mouvements, corrigerStock, showToast } = useStock();
  const [qte, setQte] = useState("");
  const [motif, setMotif] = useState("Casse / défaut");

  useEffect(() => {
    setQte("");
    setMotif("Casse / défaut");
  }, [panelRef]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") fermerPanel();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [fermerPanel]);

  if (!panelRef) return null;
  const p = findProduit(panelRef);
  if (!p) return null;
  const hist = mouvements.filter((m) => m.ref === panelRef);

  return (
    <>
      <div className="scrim" onClick={fermerPanel} />
      <aside className="panel" aria-label="Détail de l'article">
        <div className="panel-h">
          <div>
            <span className="mono muted">{p.ref}</span>
            <h2 style={{ marginTop: 2 }}>{p.nom}</h2>
            <div style={{ marginTop: 8, display: "flex", gap: 8, alignItems: "center" }}>
              <span className="loc">{p.emp}</span>
              <PillStatut statut={statut(p)} />
            </div>
          </div>
          <button className="x" type="button" onClick={fermerPanel} aria-label="Fermer">
            ✕
          </button>
        </div>
        <div className="panel-b">
          <div className="facts">
            <div>
              <span className="eyebrow">Stock</span>
              <b>{p.qte}</b>
            </div>
            <div>
              <span className="eyebrow">Seuil</span>
              <b>{p.seuil}</b>
            </div>
            <div>
              <span className="eyebrow">Prix d&apos;achat</span>
              <b>{euro(p.pa)}</b>
            </div>
          </div>
          <div className="card" style={{ padding: 14 }}>
            <h3 style={{ marginBottom: 10 }}>Corriger le stock</h3>
            <div className="row2">
              <div className="field">
                <label htmlFor="corrQte">Quantité</label>
                <input
                  id="corrQte"
                  type="number"
                  step={1}
                  placeholder="ex : -1"
                  value={qte}
                  onChange={(e) => setQte(e.target.value)}
                />
              </div>
              <div className="field">
                <label htmlFor="corrMotif">Motif</label>
                <select id="corrMotif" value={motif} onChange={(e) => setMotif(e.target.value)}>
                  <option>Casse / défaut</option>
                  <option>Erreur de saisie</option>
                  <option>Retour client</option>
                  <option>Utilisation atelier</option>
                  <option>Autre</option>
                </select>
              </div>
            </div>
            <button
              className="btn primary"
              type="button"
              style={{ marginTop: 12, width: "100%" }}
              onClick={() => {
                const v = parseInt(qte, 10);
                if (!v) return showToast("Indique une quantité, par exemple -1 ou 2");
                corrigerStock(v, motif);
                setQte("");
              }}
            >
              Appliquer la correction
            </button>
          </div>
          <div>
            <h3 style={{ marginBottom: 6 }}>Historique</h3>
            {hist.length ? (
              <ul className="feed list">
                {hist.map((m, i) => (
                  <li key={i}>
                    <span className="tag">{TYPE_LIB[m.type]}</span>
                    <span className="muted" style={{ fontSize: ".86rem", minWidth: 0 }}>
                      {m.source}
                      <br />
                      {m.quand}
                    </span>
                    <Delta d={m.delta} />
                  </li>
                ))}
              </ul>
            ) : (
              <p className="muted">Aucun mouvement récent.</p>
            )}
          </div>
        </div>
      </aside>
    </>
  );
}
